import { NavigateFunction } from 'react-router';

import { getEntityPageUrl } from 'features/Entity/utils/getEntityPageUrl';
import { ILiveEntity } from 'types/detailsEntityType';
import { ENTITY_PAGE_URL } from 'utils/defaults';

export const handleShowAllSearchResults = (
  navigate: NavigateFunction,
  inputValue: string,
  searchResults: ILiveEntity[]
) => {
  if (inputValue === '' || searchResults.length === 0) {
    return;
  }
  if (searchResults.length === 1) {
    const iLiveDetail = searchResults[0];
    navigate(`${getEntityPageUrl(iLiveDetail.entityType)}/${iLiveDetail.spaceId}`);
    return;
  }
  navigate(`${ENTITY_PAGE_URL}?searchTerm=${inputValue}`);
};
